import { Badge, Box } from '@usealloy/component-library';

interface Props {
  riskRatingColor?: string;
  riskRatingLabel?: string;
}

export const RiskScoreTabLabel = ({
  riskRatingColor,
  riskRatingLabel,
}: Props) => (
  <Box>
    Risk Score
    {riskRatingColor && riskRatingLabel && (
      <Badge
        outline
        backgroundColor={riskRatingColor}
        style={{ fontWeight: 'var(--cl-font-weight-regular)' }}
      >
        {riskRatingLabel}
      </Badge>
    )}
  </Box>
);
